// import React from "react";
// import { Paper, Typography, Box, LinearProgress } from "@mui/material";

// export default function CandidatePipelineFunnel({ funnel = [] }) {
//   const hasData = Array.isArray(funnel) && funnel.length > 0;

//   const barColors = [
//     "#6366F1",
//     "#22C55E",
//     "#F97316",
//     "#EC4899",
//     "#0EA5E9",
//   ];

//   return (
//     <Paper
//       elevation={0}
//       sx={{
//         p: 2.5,
//         mb: 3,
//         borderRadius: 2,
//         bgcolor: "#ffffff",
//         boxShadow: "0 8px 24px rgba(15,23,42,0.10)",
//         display: "flex",
//         flexDirection: "column",
//         height: "100%",
//       }}
//     >
//       {/* Header */}
//       <Box sx={{ mb: 1.5 }}>
//         <Typography
//           variant="overline"
//           sx={{
//             fontSize: 11,
//             letterSpacing: 0.8,
//             textTransform: "uppercase",
//             color: "text.secondary",
//           }}
//         >
//           Pipeline
//         </Typography>
//         <Typography variant="h6" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
//           Candidate Funnel
//         </Typography>
//       </Box>

//       {!hasData ? (
//         <Box
//           sx={{
//             py: 3,
//             textAlign: "center",
//             color: "text.secondary",
//             fontSize: 14,
//           }}
//         >
//           No pipeline data.
//         </Box>
//       ) : (
//         <Box
//           sx={{
//             display: "flex",
//             flexDirection: "column",
//             gap: 1.5,
//           }}
//         >
//           {funnel.map((stage, idx) => {
//             const color = barColors[idx % barColors.length];
//             const percentLabel =
//               typeof stage.percent === "number"
//                 ? `${Math.round(stage.percent)}%`
//                 : "";

//             return (
//               <Box key={stage.stage}>
//                 <Box
//                   sx={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "baseline",
//                     mb: 0.5,
//                     gap: 1,
//                     flexWrap: "wrap",
//                   }}
//                 >
//                   <Typography
//                     variant="body2"
//                     sx={{ fontWeight: 600 }}
//                   >
//                     {stage.stage}{" "}
//                     <Typography
//                       component="span"
//                       variant="body2"
//                       sx={{ color: "text.secondary", fontWeight: 400 }}
//                     >
//                       ({stage.count})
//                     </Typography>
//                   </Typography>
//                   {percentLabel && (
//                     <Typography
//                       variant="caption"
//                       sx={{ color: "text.secondary" }}
//                     >
//                       {percentLabel}
//                     </Typography>
//                   )}
//                 </Box>
//                 <LinearProgress
//                   variant="determinate"
//                   value={stage.percent}
//                   sx={{
//                     height: 10,
//                     borderRadius: 999,
//                     bgcolor: "rgba(148,163,184,0.25)",
//                     "& .MuiLinearProgress-bar": {
//                       borderRadius: 999,
//                       backgroundColor: color,
//                     },
//                   }}
//                 />
//               </Box>
//             );
//           })}
//         </Box>
//       )}
//     </Paper>
//   );
// }


import React from "react";
import { Paper, Typography, Box, LinearProgress, Divider } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";

export default function CandidatePipelineFunnel({ funnel = [] }) {
  const theme = useTheme();
  const dark = theme.palette.mode === "dark";

  const accent = dark ? "#fb923c" : "#f97316";
  const text = dark ? "#e8f0fe" : "#0f0f1a";
  const mid = dark ? "#94a3b8" : "#4b4b6a";
  const muted = dark ? "#4b6080" : "#9898b8";
  const border = dark ? "rgba(99, 179, 237, 0.10)" : "#e8e8f0";

  const hasData = Array.isArray(funnel) && funnel.length > 0;

  const barColors = [
    accent,
    "#22C55E",
    "#06B6D4",
    "#A855F7",
    "#F59E0B",
  ];

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.75,
        borderRadius: "22px",
        background: dark ? "rgba(13,18,32,0.96)" : "rgba(255,255,255,0.98)",
        border: `1px solid ${border}`,
        boxShadow: dark
          ? "0 20px 50px rgba(0,0,0,0.20)"
          : "0 12px 30px rgba(15,23,42,0.06)",
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      <Box sx={{ mb: 1.75 }}>
        <Typography
          sx={{
            fontSize: 11,
            letterSpacing: "0.16em",
            textTransform: "uppercase",
            color: muted,
            fontWeight: 500,
            fontFamily:
              '"DM Mono", ui-monospace, SFMono-Regular, Menlo, monospace',
          }}
        >
          Pipeline
        </Typography>

        <Typography
          sx={{
            mt: 0.6,
            fontWeight: 800,
            fontSize: "1.35rem",
            lineHeight: 1.15,
            color: text,
            letterSpacing: "-0.02em",
          }}
        >
          Candidate Funnel
        </Typography>
      </Box>

      <Divider sx={{ mb: 1.75, borderColor: border }} />

      {!hasData ? (
        <Box
          sx={{
            py: 3,
            textAlign: "center",
            color: mid,
            fontSize: 14,
          }}
        >
          No pipeline data.
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1.6,
          }}
        >
          {funnel.map((stage, idx) => {
            const color = barColors[idx % barColors.length];
            const percent =
              typeof stage.percent === "number"
                ? Math.max(0, Math.min(stage.percent, 100))
                : 0;
            const percentLabel =
              typeof stage.percent === "number" ? `${Math.round(percent)}%` : "";

            return (
              <Box key={stage.stage}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "baseline",
                    mb: 0.65,
                    gap: 1,
                    flexWrap: "wrap",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: 700,
                      color: text,
                    }}
                  >
                    {stage.stage}{" "}
                    <Typography
                      component="span"
                      sx={{
                        fontSize: "13px",
                        color: mid,
                        fontWeight: 500,
                      }}
                    >
                      ({stage.count})
                    </Typography>
                  </Typography>

                  {percentLabel && (
                    <Typography
                      sx={{
                        fontSize: "12px",
                        color: mid,
                      }}
                    >
                      {percentLabel}
                    </Typography>
                  )}
                </Box>

                <LinearProgress
                  variant="determinate"
                  value={percent}
                  sx={{
                    height: 10,
                    borderRadius: 999,
                    bgcolor: dark
                      ? "rgba(255,255,255,0.08)"
                      : "rgba(148,163,184,0.25)",
                    "& .MuiLinearProgress-bar": {
                      borderRadius: 999,
                      backgroundColor: color,
                    },
                  }}
                />
              </Box>
            );
          })}
        </Box>
      )}
    </Paper>
  );
}